import { TQFontFamily } from '@coretech/typequestweb';
import { Action } from 'redux';

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
export const UPDATE_LEFTNAV_STATUS = 'UPDATE_LEFTNAV_STATUS';
export const FETCH_SEARCH_RESULTS = 'FETCH_SEARCH_RESULTS';
export const FETCH_SEARCH_ASSETS_RESULTS = 'FETCH_SEARCH_ASSETS_RESULTS';
export const FETCH_ML_SEARCH_LINKS = 'FETCH_ML_SEARCH_LINKS';
export const FETCH_CCSTORAGE_RESULTS = 'FETCH_CCSTORAGE_RESULTS';
export const FETCH_SEARCH_HISTORY = 'FETCH_SEARCH_HISTORY';
export const FETCH_SEARCH_TRENDING = 'FETCH_SEARCH_TRENDING';
export const SET_SEARCH_HISTORY = 'SET_SEARCH_HISTORY';
export const FETCH_SEARCH_AUTO_SUGGESTION = 'FETCH_SEARCH_AUTO_SUGGESTION';
export const FETCH_INTENT_SHORTCUT_SUGGESTION = 'FETCH_INTENT_SHORTCUT_SUGGESTION';
export const FILTER_SEARCH_DROPDOWN = 'FILTER_SEARCH_DROPDOWN';
export const RESET_SEARCH = 'RESET_SEARCH';
export const SEARCH_QUERY = 'SEARCH_QUERY';
export const EXACT_TYPED_SEARCH_QUERY = 'EXACT_TYPED_SEARCH_QUERY';
export const TEMP_SEARCH_QUERY = 'TEMP_SEARCH_QUERY';
export const SHOW_SEARCH_DROPDOWN = 'SHOW_SEARCH_DROPDOWN';
export const SHOW_SEARCH_THUMBS_FEEDBACK = 'SHOW_SEARCH_THUMBS_FEEDBACK';
export const RESET_THUMBS_FEEDBACK = 'RESET_THUMBS_FEEDBACK';
export const CURRENT_SEARCH_VIEW = 'CURRENT_SEARCH_VIEW';
export const SUBMITTED_THUMBS_FEEDBACK = 'SUBMITTED_THUMBS_FEEDBACK';
export const SUBMITTED_SEARCH_QUERY = 'SUBMITTED_SEARCH_QUERY';
export const SET_SRP_CURRENT_TAB = 'SET_SRP_CURRENT_TAB';
export const SET_SEARCH_GLOBAL_CONFIG = 'SET_SEARCH_GLOBAL_CONFIG';
export const SET_YOUR_WORK_FILTERS = 'SET_YOUR_WORK_FILTERS';
export const SET_YOUR_WORK_FILTERS_SELECTED = 'SET_YOUR_WORK_FILTERS_SELECTED';
export const SET_YOUR_WORK_FILTERS_APPLIED = 'SET_YOUR_WORK_FILTERS_APPLIED';
export const SET_YOUR_WORK_FILTERS_CLEARED = 'SET_YOUR_WORK_FILTERS_CLEARED';
export const SET_YOUR_WORK_FILTERS_DISPLAY = 'SET_YOUR_WORK_FILTERS_DISPLAY';
export const SET_THEME = 'SET_THEME';
export const SET_SEARCH_RESULTS_TOTAL_COUNT_BY_TAB = 'SET_SEARCH_RESULTS_TOTAL_COUNT_BY_TAB';
export const SET_PREVIOUS_SEARCH_QUERY = 'SET_PREVIOUS_SEARCH_QUERY';
export const FETCH_SEARCH_APP_METADATA = 'FETCH_SEARCH_APP_METADATA';
export const SET_SEARCH_DROPDOWN_CURRENT_SECTION_ITEM = 'SET_SEARCH_DROPDOWN_CURRENT_SECTION_ITEM';
export const SET_YOUR_WORK_FILTER_CHIPS = 'SET_YOUR_WORK_FILTER_CHIPS';
export const UPDATE_SELECTED_FILTER_OPTIONS = 'UPDATE_SELECTED_FILTER_OPTIONS';
export const UPDATE_PRE_SEARCH_RECOMMENDATIONS = 'UPDATE_PRE_SEARCH_RECOMMENDATIONS';
export const UPDATE_BOT_SUGGESTIONS = 'UPDATE_BOT_SUGGESTIONS';
export const FETCH_PRESEARCH_RESULTS = 'FETCH_PRESEARCH_RESULTS';
export const FETCH_FONT_SEARCH_RESULTS = 'FETCH_FONT_SEARCH_RESULTS';
export const FETCH_SEARCH_GEN_SUMMARY = 'FETCH_SEARCH_GEN_SUMMARY';
export const FETCH_USER_PREFERENCES = 'FETCH_USER_PREFERENCES';
export const STORE_USER_PREFERENCES = 'STORE_USER_PREFERENCES';
export const FETCH_SEARCH_GEN_SUMMARY_IN_PROGRESS = 'FETCH_SEARCH_GEN_SUMMARY_IN_PROGRESS';
export const SET_SOURCE_OF_QUERY = 'SET_SOURCE_OF_QUERY';
export const SET_QUERY_INTENT = 'SET_QUERY_INTENT';
export const SET_FONT_SEARCH_RESULTS = 'SET_FONT_SEARCH_RESULTS';
export const FETCH_SAYT_FILES = 'FETCH_SAYT_FILES';
export const FETCH_RECENT_FILES = 'FETCH_RECENT_FILES';
/**
 * TODO:To improve typings in future when we add more action types use below structure
 */

export interface IUpdateLeftnavStatus extends Action<'UPDATE_LEFTNAV_STATUS'> {
	payload: Record<string, any>;
}
export interface IResetSearch extends Action<'RESET_SEARCH'> {
	payload: Record<string, any>;
}
export interface IFetchSearchResults extends Action<'FETCH_SEARCH_RESULTS'> {
	payload: Record<string, any>;
	meta: string;
}

export interface IFetchPreSearchResults extends Action<typeof FETCH_PRESEARCH_RESULTS> {
	payload: Record<string, any>;
}
export interface ISetSearchDropdownCurrentSectionItemAction extends Action<'SET_SEARCH_DROPDOWN_CURRENT_SECTION_ITEM'> {
	payload: string;
}
export interface ISetYourWorkFilterChips extends Action<'SET_YOUR_WORK_FILTER_CHIPS'> {
	type: 'SET_YOUR_WORK_FILTER_CHIPS';
}
export interface IUpdateSelectedFilterOptionsAction extends Action<'UPDATE_SELECTED_FILTER_OPTIONS'> {
	payload: {
		index: number;
		filterOption: YourWorkFilterOption;
	};
}

export interface IUpdatePreSearchRecommendation extends Action<'UPDATE_PRE_SEARCH_RECOMMENDATIONS'> {
	payload: {
		recommendations: Record<string, any>;
	};
}
export interface IUpdateBotSuggestions extends Action<typeof UPDATE_BOT_SUGGESTIONS> {
	payload: {
		botSuggestions: Array<BotSuggestion>;
	};
}
export interface IFetchIntentShortcutSuggestions extends Action<typeof FETCH_INTENT_SHORTCUT_SUGGESTION> {
	payload: {
		searchAutoCompleteIntentShortcuts: Array<AppResultItem>;
		searchAutoCompleteIntentTerms: Array<string>;
	};
}
export interface IFetchFontSearchResults extends Action<typeof FETCH_FONT_SEARCH_RESULTS> {
	payload: Array<TQFontFamily>;
}

export interface IFetchSAYTFiles extends Action<typeof FETCH_SAYT_FILES> {
	payload: {
		matched?: Array<Record<string, any>>;
		all?: Array<Record<string, any>>;
		recent?: Array<Record<string, any>>;
		query?: string;
	};
}

export interface IFetchRecentFiles extends Action<typeof FETCH_RECENT_FILES> {
	payload: {
		matched?: Array<Record<string, any>>;
		all?: Array<Record<string, any>>;
		recent?: Array<Record<string, any>>;
		query?: string;
	};
}
